var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486 265h26v-71H0v71h486z",
    fill: "#4f9f06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 477h388l36-212H26zm123-177c-123 141-61 71 0 0z",
    fill: "#5fc602"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79 203l7-2 6-7L236 50a9 9 0 0 0-13-12L73 188a9 9 0 0 0 6 15zM433 203a9 9 0 0 0 6-15L289 38a9 9 0 0 0-13 12l144 144 6 7 7 2z",
    fill: "#195c85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#346608",
    d: "M238 300h35v141h-35zM150 300h35v141h-35zM327 300h35v141h-35z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 247c5 0 9-4 9-9v-17a9 9 0 0 0-17 0v17c0 5 4 9 8 9zM433 247c4 0 8-4 8-9v-17a9 9 0 0 0-17 0v17c0 5 4 9 9 9z",
    fill: "#195c85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping-basket.66011b4ceb65d8f9ba2edb17f9ee4bb6.svg";
export { ForwardRef as ReactComponent };